import { persistor } from '../store';

export function updateField(form, name, value) {
  return {
    type: 'FORM_FIELD_UPDATE',
    form,
    name,
    value,
  };
}

export function updateConditionalInputField(form, name, value) {
  return {
    type: 'FORM_FIELD_CONDITIONAL_INPUT_UPDATE',
    form,
    name,
    value,
  };
}

export function addDocument(form, name, documents) {
  return {
    type: 'FORM_ADD_DOCUMENT',
    form,
    name,
    documents,
  };
}

export function removeDocument(form, index) {
  return {
    type: 'FORM_REMOVE_DOCUMENT',
    form,
    index,
  };
}

export function submitForm(form, index) {
  return {
    type: 'FORM_SUBMIT_STEP',
    form,
    index,
  };
}

export function nextForm(form, index) {
  return {
    type: 'FORM_NEXT',
    form,
    index,
  };
}

export function backForm(form, index) {
  return {
    type: 'FORM_BACK',
    form,
    index,
  };
}

export function editForm(name, index, formType) {
  return {
    type: 'FORM_EDIT_STEP',
    name,
    index,
    formType,
  };
}

export function setShowPreview(showPreview) {
  return {
    type: 'FORM_SHOW_PREVIEW',
    showPreview,
  };
}

export function submitContactForm(action) {
  return function (dispatch, getState) {
    dispatch({ type: 'CONTACT_FORM_SUBMIT' });

    const formData = getState().forms;

    const postData = {
      FirstName: formData.contactUs.firstName.value,
      LastName: formData.contactUs.lastName.value,
      Email: formData.contactUs.emailAddress.value,
      Region: formData.contactUs.region.value,
      ajax: 1,
    };

    const formBody = new window.FormData();

    for (let name in postData) {
      formBody.append(name, postData[name]);
    }

    let relevantFiles = formData.relevantDocuments.documents.value;

    for (let i = 0; i < relevantFiles.length; i++) {
      formBody.append(
        'RelevantDocument' + (i + 1),
        relevantFiles[i].file,
        relevantFiles[i].file.name
      );
    }

    formBody.append('upload_file', '1');

    const headers = new window.Headers();
    headers.append('Access-Control-Allow-Origin', '*');
    headers.append('Accept', 'application/json');
    headers.append('Content-Type', 'application/json');

    window
      .fetch(action, {
        method: 'POST',
        body: formBody,
      })
      .then((res) => res.json())
      .then((response) => {
        dispatch({ type: 'RESET_STORE' });
        persistor.purge();

        window.location.href = `${response.Location}?SessionID=${response.SessionID}`;
      });
  };
}

export function submitReportForm(action) {
  return function (dispatch, getState) {
    dispatch({ type: 'FORM_SUBMIT' });

    const formData = getState().forms;

    const formBody = new window.FormData();
    const {
      bankDetails,
      relationDetails,
      concernDetails,
      expectationDetails,
      personalDetails,
      demographicInformation,
    } = formData;

    const postData = {
      ajax: 1,
      Bank: bankDetails.bank.value,
      RelationshipBank: relationDetails.bankRelationship.value,
      Issue: concernDetails.concern.value,
      Expectation: expectationDetails.expectation.value,
      PersonalInformationOption: personalDetails.personalPrivacy.value,
      FirstName: personalDetails.firstName.value,
      LastName: personalDetails.lastName.value,
      Email: personalDetails.emailAddress.value,
      Phone: personalDetails.phoneNumber.value,
      Region: personalDetails.region.value,
      Communication: personalDetails.contactPreference.value,
      CommunicationPreferences: personalDetails.preferences.value,
      DemographicAge: demographicInformation.demographicAge.value,
    };

    Object.entries(postData).forEach(([name, value]) => {
      formBody.append(name, value);
    });

    const relevantFiles = formData.documentsDetails.documents.value;

    for (let i = 0; i < relevantFiles.length; i++) {
      formBody.append(
        'RelevantDocument' + (i + 1),
        relevantFiles[i].file,
        relevantFiles[i].file.name
      );
    }

    formBody.append('upload_file', '1');

    const headers = new window.Headers();
    headers.append('Access-Control-Allow-Origin', '*');
    headers.append('Accept', 'application/json');
    headers.append('Content-Type', 'application/json');
    window
      .fetch(action, {
        method: 'POST',
        body: formBody,
      })
      .then((res) => res.json())
      .then((response) => {
        dispatch({ type: 'RESET_STORE' });
        persistor.flush();
        persistor.purge();

        dispatch({
          type: 'FORM_SUBMIT_RESPONSE',
        });

        window.location.href = `${response.Location}?SessionID=${response.SessionID}`;
      })
      .catch((error) => {
        dispatch({
          type: 'FORM_SUBMIT_RESPONSE_ERROR',
          error,
        });
      });
  };
}

export function submitCompleteForm(action) {
  return function (dispatch, getState) {
    dispatch({ type: 'FORM_SUBMIT' });

    const formData = getState().forms;

    const formBody = new window.FormData();
    const {
      representativeDetails,
      contactDetails,
      yourComplaint,
      yourExpectations,
      privacyAuthorisation,
      demographicInformation,
    } = formData;

    const postData = {
      ajax: 1,
      OnBehalf: representativeDetails.onBehalf.value,
      PersonalTitle: contactDetails.title.value,
      FirstName: contactDetails.firstName.value,
      LastName: contactDetails.lastName.value,
      Pronouns: contactDetails.pronounsOther.value
        ? contactDetails.pronounsOther.value
        : contactDetails.pronouns.value,
      Email: contactDetails.emailAddress.value,
      Organisation: contactDetails.organisation.value,
      Phone: contactDetails.phoneNumber.value,
      Region: contactDetails.region.value,
      Preferences: contactDetails.preferences.value,
      Bank: yourComplaint.bank.value,
      Complaint: yourComplaint.complaint.value,
      Expectation: yourExpectations.expectation.value,
      PrivacyAgreement: privacyAuthorisation.privacyAgreement.value,
      DemographicAge: demographicInformation.demographicAge.value,
      DemographicGender: demographicInformation.demographicGender.value,
      DemographicGenderDetails:
        demographicInformation.demographicGenderOther.value,
      DemographicEthnicity: demographicInformation.demographicEthnicity.value
        .filter((n) => n)
        .join('; '),
      DemographicEthnicityDetail:
        demographicInformation.demographicEthnicity.conditionalInputValue
          .filter((n) => n)
          .join('; '),
      DemographicFindOutReferral:
        demographicInformation.demographicFindOutReferral.value,
      DemographicFindOutReferralDetail:
        demographicInformation.demographicFindOutReferralDetail.value,
    };

    if (representativeDetails.onBehalf.value !== 'Myself') {
      postData.RepPersonalTitle = representativeDetails.repPersonalTitle.value;
      postData.RepPronouns = representativeDetails.repPronounsOther.value
        ? representativeDetails.repPronounsOther.value
        : representativeDetails.repPronouns.value;
      postData.RepFirstName = representativeDetails.repFirstName.value;
      postData.RepLastName = representativeDetails.repLastName.value;
      postData.RepRelationship = representativeDetails.repRelationship.value;
      postData.RepOrganisation = representativeDetails.repOrganisation.value;
      postData.RepEmail = representativeDetails.repEmail.value;
      postData.RepPhone = representativeDetails.repPhone.value;
      postData.Preferences = representativeDetails.preferences.value;
    }

    Object.entries(postData).forEach(([name, value]) => {
      formBody.append(name, value);
    });

    let relevantFiles = formData.relevantDocuments.documents.value;

    for (let i = 0; i < relevantFiles.length; i++) {
      formBody.append(
        'RelevantDocument' + (i + 1),
        relevantFiles[i].file,
        relevantFiles[i].file.name
      );
    }

    formBody.append('upload_file', '1');

    const headers = new window.Headers();
    headers.append('Access-Control-Allow-Origin', '*');
    headers.append('Accept', 'application/json');
    headers.append('Content-Type', 'application/json');
    window
      .fetch(action, {
        method: 'POST',
        body: formBody,
      })
      .then((res) => res.json())
      .then((response) => {
        dispatch({ type: 'RESET_STORE' });
        persistor.purge();

        dispatch({
          type: 'FORM_SUBMIT_RESPONSE',
        });

        window.location.href =
          response.Location + '?SessionID=' + response.SessionID;
      })
      .catch((error) => {
        console.error(error);
        // we got back error response. so We should take the user back to the form
        // and show the error message

        dispatch({
          type: 'FORM_SUBMIT_RESPONSE_ERROR',
          error,
        });
      });
  };
}

export function submitDownloadReport(action) {
  return function (dispatch, getState) {
    const formData = getState().forms;

    const {
      bankDetails,
      relationDetails,
      concernDetails,
      expectationDetails,
      personalDetails,
      agreementDetails,
    } = formData;

    const postData = {
      ajax: 1,
      formAction: action,
      Bank: bankDetails.bank.value,
      RelationshipBank: relationDetails.bankRelationship.value,
      Issue: concernDetails.concern.value,
      Expectation: expectationDetails.expectation.value,
      PersonalInformationOption: personalDetails.personalPrivacy.value,
      FirstName: personalDetails.firstName.value,
      LastName: personalDetails.lastName.value,
      Email: personalDetails.emailAddress.value,
      Phone: personalDetails.phoneNumber.value,
      Region: personalDetails.region.value,
      Communication: personalDetails.contactPreference.value,
      CommunicationPreferences: personalDetails.preferences.value,
      PrivacyAgreement: agreementDetails.privacyAgreement.value,
    };

    const headers = new window.Headers();

    headers.append('Access-Control-Allow-Origin', '*');
    headers.append('Accept', 'application/pdf');
    headers.append('Content-Type', 'application/json');

    let joinedAction = window.location.href;

    // add downloadPDF to the action
    joinedAction = `${joinedAction.replace(/\/$/, '')}/downloadPdf/`;

    window
      .fetch(joinedAction, {
        method: 'POST',
        body: JSON.stringify(postData),
        headers,
      })
      .then((response) => response.blob())
      .then((blob) => URL.createObjectURL(blob))
      .then((url) => {
        window.open(url, '_blank');
      });
  };
}

export function getBanks() {
  return function (dispatch) {
    dispatch({ type: 'GET_BANKS' });

    window
      .fetch('/banks')
      .then((response) => response.json())

      .then((response) => {
        dispatch({
          type: 'GET_BANKS_RESPONSE',
          options: response.data,
          banksStatus: 'loading',
        });
      })
      .catch((error) => console.error(error));
  };
}

export function getWhistleBlowerBanks() {
  return function (dispatch) {
    dispatch({ type: 'GET_BANKS' });

    window
      .fetch('/banks/whistleblowList')
      .then((response) => response.json())

      .then((response) => {
        dispatch({
          type: 'GET_BANKS_RESPONSE',
          options: response.data,
          banksStatus: 'loading',
        });
      })
      .catch((error) => console.error(error));
  };
}
